import { z } from "zod";

export const formSchema = z.object({
  order_id: z.number(),
  status: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      reason_for_reject: z.string().optional(),
      status: z.enum(["Accept", "Reject"])
    })
  )
});

export type BookingFormValues = z.infer<typeof formSchema>;